const swedishCollator = new Intl.Collator("sv", {
  sensitivity: "base",
  numeric: true,
});

export const compareStrings = (a, b) =>
  swedishCollator.compare(String(a ?? "").trim(), String(b ?? "").trim());

export const compareByName = (a, b) => compareStrings(a?.name, b?.name);
